export default __webpack_public_path__ + "static/media/Flaticon.11736f8b.ttf";